import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords', {
        url: '/shared-passwords',
        component: 'companySharingCenterSharedPasswords',
        resolve: {accounts},
    });
}

/** @ngInject */
function accounts($filter, companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllByCompany({companyId}, {}).$promise
        .then(accounts => accounts.filter(account => !account.enabled2fa))
        .then(accounts => $filter('orderBy')(accounts, 'publicService.serviceName'))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/shared-passwords.state.js